export interface FeedbackLaneProps {
  tone?: "quiet" | "attention" | "success" | "mismatch";
  children: React.ReactNode;
}

export function FeedbackLane({ tone = "quiet", children }: FeedbackLaneProps) {
  return (
    <div
      className={`feedback-lane feedback-${tone}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {children}
    </div>
  );
}
